import axios from 'axios';
import { GET_ITEMS, GET_FILTERED_ITEMS, API_HOST } from './const';

const API_URL = '/api/Gym/GetItems/';

export default (query, assocs, all = false) => {
  if (all) {
    const url = `${API_HOST}${API_URL}?query=${query}&assocs=${assocs}&all=true`;
    const request = axios.get(url);

    // sessionStorage.setItem('gym-query', query);
    // sessionStorage.setItem('gym-assocs', assocs);

    return {
      type: GET_ITEMS,
      payload: request,
    };
  }

  return {
    type: GET_FILTERED_ITEMS,
    payload: {
      query: query.trim().toLowerCase(),
      assocs: assocs.trim() === '' ? [] : assocs.split(',').map((x) => parseInt(x, 10)),
    },
  };
};
